define(["exports", "react", "styled-components", "../../themes", "../../utils"], function (_exports, _react, _styledComponents, _themes, _utils) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var Chat = _styledComponents.default.button.withConfig({
    displayName: "ChatButton__Chat",
    componentId: "sc-jr6ayx-0"
  })(["", ";display:flex;align-items:center;color:", ";height:16px;span{font-size:1.5em;}box-icon{fill:currentColor;margin-left:2px;}"], _themes.resetButton, function (_ref) {
    var theme = _ref.theme;
    return theme.colors.white;
  });

  var ChatButton = function ChatButton(_ref2) {
    var funcionario = _ref2.funcionario,
        cliente = _ref2.cliente,
        chatFetchLink = _ref2.chatFetchLink,
        chatRedirect = _ref2.chatRedirect;
    var info = {
      participante: {
        equipe: {
          nome: cliente.nome,
          avatar: 'null',
          sistema_equipe_id: cliente.id
        },
        perfil_sistema: {
          perfil: 'recrutador',
          sistema: 'e-parthenon',
          dominio: 'www.vagas.com.br'
        },
        sistema_usuario_id: funcionario.id,
        nome: funcionario.nome,
        avatar: 'null'
      }
    };

    var _useState = (0, _react.useState)(false),
        loader = _useState[0],
        setLoader = _useState[1];

    var handleClick = function handleClick() {
      setLoader(true);
      fetch(chatFetchLink, {
        method: 'post',
        body: JSON.stringify(info),
        credentials: 'include',
        headers: {
          Authorization: "Bearer " + (0, _utils.getCookie)('access%5Ftoken'),
          'Content-Type': 'application/json',
          'Accept-Language': 'pt-BR',
          'Access-Control-Allow-Origin': window.location.origin
        }
      }).then(function () {
        return window.location.href = chatRedirect;
      }).catch(function () {
        setLoader(false);
      });
    };

    return /*#__PURE__*/_react.default.createElement(Chat, {
      onClick: handleClick,
      disabled: loader
    }, loader ? /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "loader-circle",
      animation: "spin"
    }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, "Chat"), /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "chat",
      size: "18px"
    })));
  };

  var _default = ChatButton;
  _exports.default = _default;
});